import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { VgCoreModule } from '@videogular/ngx-videogular/core';

@Component({
    selector: 'app-modalevidenciaincidencia',
    standalone: true,
    templateUrl: './modalEvidencia.component.html',
    styleUrls: ['./modalEvidencia.component.css'],
    imports: [MatIconButton, MatIcon, CdkScrollable, MatDialogContent, NgIf, VgCoreModule]
})
export class ModalEvidenciaComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) private parameter: any,
    public dialogRef: MatDialogRef<ModalEvidenciaComponent>
  ) { }

  image: any;
  show: boolean;
  nombre: any;
  /** MIME real del archivo; se usa para que <video> acepte el blob. */
  mimeType: string;
  /** Se activa cuando el navegador no puede pintar/reproducir el archivo. */
  errorCarga = false;

  ngOnInit() {
    if (this.parameter.imagen) {
      this.image = this.parameter.imagen;
      this.nombre = this.parameter.NombreEvidencia;
      this.show = this.parameter.show;
      this.mimeType =
        this.parameter.mimeType || (this.parameter.show ? 'image/jpeg' : 'video/mp4');
    } else {
      this.dialogRef.close();
    }
  }

  onErrorCarga() {
    this.errorCarga = true;
  }

  onCloseClick() {
    this.dialogRef.close();
  }
}
